import { AttachmentInterface } from '../attachments/attachment.interface';
import { SimpleElementInterface } from '../simpleElement.interface';

export class OrderAuctionInfoDTO {
  constructor(
    public auctionId: string,
    public name: string,
    public label: string,
    public manufacturer: SimpleElementInterface,
    public coverPhoto?: AttachmentInterface,
    public offerCount?: number,
  ) {}
}
